import React, { Suspense, useEffect } from 'react'
import { useLocation, useRoutes } from 'react-router-dom'
import { MainRouteMapper } from './MainRouteMapper'

export default function RouteIndex() {
  const { pathname } = useLocation()
  const mainRouteMapper = useRoutes([
    ...MainRouteMapper
  ])

  useEffect(() => {
    const isImageShareRoute = ['/shd-image-share', '/nkc-img-share'].includes(
      pathname.toLowerCase().replace(/\/+$/, '') || '/'
    )
    const title = isImageShareRoute ? 'SHD image share' : 'zamanShahed'
    const description = isImageShareRoute
      ? 'This page is only visible to whom we have shared the link, and private otherwise. All images will be removed after 16th Oct. PLEASE DOWNLOAD YOUR COPY BEFORE...'
      : 'The portfolio of Zaman Shahed, featuring projects, skills, experience, and education.'
    const previewImage = isImageShareRoute
      ? 'https://i.ibb.co.com/Wp7RBMQh/IMG-5187.jpg'
      : null

    document.title = title

    const setMetaTag = (attribute, key, value) => {
      const selector = `meta[${attribute}="${key}"]`
      let tag = document.head.querySelector(selector)

      if (value === null) {
        tag?.remove()
        return
      }

      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute(attribute, key)
        document.head.appendChild(tag)
      }

      tag.setAttribute('content', value)
    }

    setMetaTag('name', 'title', title)
    setMetaTag('name', 'description', description)
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:type', 'website')
    setMetaTag('property', 'og:image', previewImage)
    setMetaTag('name', 'twitter:title', title)
    setMetaTag('name', 'twitter:description', description)
    setMetaTag('name', 'twitter:card', isImageShareRoute ? 'summary_large_image' : 'summary')
    setMetaTag('name', 'twitter:image', previewImage)
  }, [pathname])

  return (
    <Suspense fallback={''}>
      {mainRouteMapper}
    </Suspense>
  )
}
